import API from 'shared/lib/api'

export default {

  // Fetches resource from the API.
  //
  // @example
  //   SomeModel.actions.fetch({ id: 1 })
  //
  actionMethod: (model, options = {}) => {
    const { id, ...optionsWithoutId } = options
    optionsWithoutId.apiVersion = optionsWithoutId.apiVersion ?? model.options.apiVersion

    return API.getResource(model.pluralName, id, optionsWithoutId)
  },

  // Updates flags on collection.
  //
  reduceMethod: (model, collection, action) => {
    switch (action.type) {
      case model.actionTypes.FETCH_START:
        return collection.set('isLoadingResource', true)

      case model.actionTypes.FETCH_ERROR:
        return collection.set('isLoadingResource', false)

      case model.actionTypes.FETCH_SUCCESS:
        return collection.set('isLoadingResource', false)
    }
  }
}
